import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserMessages } from "../../service/UserApi";
import { Loading } from "../../components/shared";

const MessagesDetails = () => {
  const user = useSelector((state) => state.user);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!user.email) return;

      setLoading(true);
      try {
        const response = await getUserMessages(user.email);
        setMessages(response?.messages || []);
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [user.email]);

  if (loading) return <Loading />;
  if (!messages.length) return <p>செய்திகள் இல்லை</p>; // "No messages"

  const sortedMessages = [...messages].sort(
    (a, b) => b.createdAt._seconds - a.createdAt._seconds
  );

  const formatDate = (timestamp) =>
    new Date(timestamp * 1000).toLocaleString("ta-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <br />
      <h4>செய்திகள்</h4>
      <br />
      <div style={{ overflowX: "auto" }}>
        <table style={tableStyle}>
          <thead>
            <tr style={headerRowStyle}>
              <th style={thStyle}>தலைப்பு</th>
              <th style={thStyle}>விவரம்</th>
              <th style={thStyle}>நேரம்</th>
            </tr>
          </thead>
          <tbody>
            {sortedMessages.map((msg, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: msg.read ? "#f9f9f9" : "#fff",
                  fontWeight: msg.read ? "normal" : "bold",
                }}
              >
                <td style={tdStyle}>{msg.title || "Message"}</td>
                <td style={tdStyle}>{msg.body}</td>
                <td style={{ ...tdStyle, color: msg.read ? "green" : "red", fontStyle: "italic" }}>
                  {formatDate(msg.createdAt._seconds)}
                  <br />
                  {msg.read ? "படிக்கப்பட்டது" : "புதியது"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

// 🧾 Inline styles
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const headerRowStyle = {
  backgroundColor: "#f0f0f0",
  textAlign: "left",
};

const thStyle = {
  padding: "8px 12px",
  borderBottom: "2px solid #ddd",
};

const tdStyle = {
  padding: "8px 12px",
  borderBottom: "1px solid #eee",
  verticalAlign: "top",
};

export default MessagesDetails;
